import React from 'react'
import { Container, Row } from 'react-bootstrap'
import Company from '../components/Company'
import Leistungen from '../components/Leistungen'
import Pflanzgefaese from '../components/Pflanzgefaese';

export default function Home() {
    return (
        <Container fluid>
            <Row id="gestaltung" className="mb-5 py-5">
                <Leistungen />
            </Row>
            <Row id="company" className="my-5 py-5">
                <Company />
            </Row>
            <Row>
                <Pflanzgefaese />
            </Row>
        </Container>
    )
}
